




















































import { FromStore } from "@abaco/web-common/src/app";
import { ToastOptions } from "@abaco/web-common/src/app/Toasted";
import { Debounce } from "vue-debounce-decorator";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Ref, Vue, Watch } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../index";
import { Subject, SubjectResponse } from "../models/Subject";

@Component
export default class SubjectsList extends Vue {
    @Inject() toast!: (message: string, options?: ToastOptions) => void;
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @FromStore(MODULE_ID) isSignleSubject!: boolean;
    @FromStore(MODULE_ID) currentSubject!: Subject | null;
    @Ref() readonly searchInput!: Vue;

    subjectResponse: SubjectResponse = new SubjectResponse();
    search = "";
    loading = true;

    @Debounce(350)
    @Watch("search")
    async searchSubject() {
        await this.loadData();
    }

    focusOnSearch() {
        this.searchInput?.$el?.querySelector("input")?.focus();
    }

    get singleSubject(): boolean {
        return this.subjectResponse.isSingle() && !this.search;
    }

    async loadData() {
        try {
            this.loading = true;
            this.isSignleSubject = true;
            this.subjectResponse = await this.maltaModule.maltaApi.getSubjects(this.search);

            if (this.singleSubject) {
                this.currentSubject = this.subjectResponse.subjects[0];
                this.$router.push({
                    name: "contractsList",
                    params: {
                        subjectId: this.subjectResponse.subjects[0].subject_id
                    },
                    replace: true
                });
            } else {
                this.loading = false;
            }
        } catch (err) {
            this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
            this.loading = false;
        }
    }

    selectSubject(subject: Subject) {
        this.currentSubject = subject;
        this.$router.push({
            name: "contractsList",
            params: {
                subjectId: subject.subject_id
            }
        });
    }

    async mounted() {
        await this.loadData();
    }
}
